import {
    Autocomplete,
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    Stack,
    TextField,
    Typography,
    Paper,
    CircularProgress
} from "@mui/material"
import { FC, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useTicketStore } from "../../../hooks/useTicketStore"
import { Ticket } from "../../../types/slices/ticketType"
import { moneyCL } from "../../../toolbox/helpers/money-helpers"
import { useWayToPayStore } from "../../../hooks/useWayToPayStore"
import { ApiStatus } from "../../../types/api/status"
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar"
import { RoutesMap } from "../../../types"
import { ClientAdress } from "../../../types/slices/clientAdressType"
import { useClientAddressStore } from "../../../hooks/useClientAddressStore"
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

export const ClientPreviewTicket: FC = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const idticket: any = id

    const { status, getTicket, tickets, confirmTicket } = useTicketStore()
    const { getWayToPayByCompany } = useWayToPayStore()
    const { clientAddresses, getClientAddresses } = useClientAddressStore()

    const [ticket, setTicket] = useState<Ticket | null>(null)
    const [selectedWayToPay, setSelectedWayToPay] = useState<any>(null)
    const [selectedBussines, setSelectedBussines] = useState<any>(null)
    const [paymentMethods, setPaymentMethods] = useState<any>([])
    const [showSaveSettingModal, setShowSaveSettingModal] = useState<boolean>(false)
    const [consultedConfiguration, setConsultedConfiguration] = useState<boolean>(false)
    const [documentSelected, setDocumentSelected] = useState<any>(null)
    const [sellerSelected, setSellerSelected] = useState<any>(null)
    const [selectedAddress, setSelectedAddress] = useState<ClientAdress | null>(null)

    useEffect(() => {
        getTicket({ id: idticket, status: 0 })
        getWayToPayApi()
    }, [])

    useEffect(() => {
        if (tickets.length > 0) setTicket(tickets[0])
    }, [tickets])

    useEffect(() => {
        if (ticket?.idcustomer) {
            getClientAddresses({ idclient: ticket?.idcustomer })
        }
    }, [ticket])

    useEffect(() => {
        if (ticket && paymentMethods.length > 0) {
            const wayToPay = paymentMethods.find(row => row.id === ticket.idway_to_pay)
            setSelectedWayToPay(wayToPay || null)
        }
    }, [ticket, paymentMethods])

    useEffect(() => {
        if (ticket?.idclient_address && clientAddresses.length > 0) {
            const address = clientAddresses.find(row => row.id === ticket.idclient_address)
            setSelectedAddress(address || null)
        }
    }, [ticket, clientAddresses])

    const getWayToPayApi = async (search = '') => {
        try {
            const response = await getWayToPayByCompany(search)
            const newData: any = []
            response && response.length > 0 && response.map((item) => {
                newData.push({
                    ...item,
                    idcuotas: JSON.parse(item.idcuotas),
                    idtools: JSON.parse(item.idtools),
                })
            })
            setPaymentMethods(newData || [])
        } catch (error) {
            console.log(error)
        }
    }

    const goBack = () => navigate(-1)

    const onConfirmTicket = async (id: number) => {
        if (!selectedWayToPay) return CustomSnackbar('warning', 'Seleccione una forma de pago.')
        if (!selectedAddress) return CustomSnackbar('warning', 'Seleccione una dirección de entrega.')

        const payload = {
            idway_to_pay: selectedWayToPay?.idway_to_pay,
            idclient_address: selectedAddress?.id,
        }

        const resp = await confirmTicket(id, payload)
        if (resp === true) {
            navigate({ pathname: RoutesMap.SEARCHER_COMPANY })
        }
    }

    if (!ticket) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                <CircularProgress size={40} sx={{ color: '#516E80' }} />
            </Box>
        )
    }

    return (
        <Box sx={{ px: { xs: 2, md: 4 }, py: 5, bgcolor: "#f0f2f5", minHeight: "100vh" }}>
            <Paper elevation={3} sx={{ maxWidth: 1100, mx: "auto", p: { xs: 3, md: 4 }, borderRadius: 3 }}>
                <Typography
                    variant="h5"
                    style={{ fontWeight: 'bolder' }}
                    color="#516E80"
                    mb={1}
                    sx={{ textAlign: 'center' }}
                >
                    CONFIRMACIÓN DEL PEDIDO
                </Typography>
                <Typography
                    variant="body2"
                    style={{ fontWeight: 'bolder' }}
                    sx={{ textAlign: 'center' }}
                >
                    Revise y confirme los detalles antes de generar el pedido.
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Grid container spacing={3}>
                    {/* Información del Ticket */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" fontWeight={600}>
                            🧾 Información del Ticket
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="N° Ticket"
                            value={ticket.nro_ticket}
                            fullWidth
                            size="small"
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Fecha"
                            value={ticket.date_format}
                            fullWidth
                            size="small"
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>

                    {/* Cliente y Dirección */}
                    <Grid item xs={12} md={6}>
                        <Stack spacing={2}>
                            <Typography variant="subtitle1" fontWeight={600}>
                                👤 Cliente
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <TextField label="Nombre" value={ticket.name_customer} fullWidth size="small" InputProps={{ readOnly: true }} />
                            <TextField label="RUT" value={ticket.rut_customer} fullWidth size="small" InputProps={{ readOnly: true }} />
                            <TextField label="Giro" value={ticket.giro_customer} fullWidth size="small" InputProps={{ readOnly: true }} />
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Stack spacing={2}>
                            <Typography variant="subtitle1" fontWeight={600}>
                                🚚 Dirección de Entrega
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Autocomplete
                                value={selectedAddress || null}
                                options={clientAddresses}
                                getOptionLabel={(opt) => opt?.address || ''}
                                isOptionEqualToValue={(opt, val) => opt?.address === val?.address}
                                onChange={(e, newValue) => setSelectedAddress(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Dirección" fullWidth size="small" />
                                )}
                            />
                        </Stack>
                    </Grid>

                    {/* Forma de pago */}
                    <Grid item xs={12}>
                        <Stack spacing={2}>
                            <Typography variant="subtitle1" fontWeight={600}>
                                💳 Forma de Pago
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Autocomplete
                                value={selectedWayToPay || null}
                                options={paymentMethods}
                                getOptionLabel={(opt) => opt?.wayToPay || ''}
                                isOptionEqualToValue={(opt, val) => opt.wayToPay === val?.wayToPay}
                                onChange={(e, newVal) => setSelectedWayToPay(newVal)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Forma de pago" fullWidth size="small" />
                                )}
                            />
                        </Stack>
                    </Grid>

                    {/* Detalles del Pedido */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" fontWeight={600} mb={1}>
                            📦 Detalles del Pedido
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        {ticket.details.length === 0 ? (
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                No hay detalles registrados.
                            </Typography>
                        ) : (
                            <Stack spacing={1}>
                                {ticket.details.map((item, index) => (
                                    <Card key={index} variant="outlined" sx={{ borderRadius: 2, p: 2, bgcolor: '#f9fafa' }}>
                                        <Stack spacing={0.5}>
                                            <Typography variant="body2"><strong>Producto:</strong> {item.product}</Typography>
                                            <Grid container>
                                                <Grid item xs={4}>
                                                    <Stack direction="row" justifyContent="space-between">
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            <strong>Cantidad:</strong>
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ fontWeight: 500, pr: 3 }}>
                                                            {item.amount} {item?.unitmeasure_abr || ''}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <Stack direction="row" justifyContent="space-between">
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            <strong>P/U:</strong>
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ fontWeight: 500, pr: 3 }}>
                                                            {moneyCL(item.price)}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>

                                                <Grid item xs={4}>
                                                    <Stack direction="row" justifyContent="space-between">
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            <strong>Total:</strong>
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            {moneyCL(item.net_subtotal)}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Stack>
                                    </Card>
                                ))}
                            </Stack>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1" fontWeight={600} mb={1}>
                            🧾 Resumen del Pedido
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Card sx={{ borderRadius: 'none', boxShadow: 'none' }}>
                            <CardContent>
                                <Stack spacing={1}>
                                    <Stack direction="row" justifyContent="space-between">
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Subtotal</Typography>
                                        <Typography variant="body2" >{moneyCL(ticket?.sub_total || 0)}</Typography>
                                    </Stack>

                                    <Stack direction="row" justifyContent="space-between">
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Descuento</Typography>
                                        <Typography variant="body2" >{moneyCL(ticket?.total_discount || 0)}</Typography>
                                    </Stack>

                                    <Stack direction="row" justifyContent="space-between">
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Monto Neto</Typography>
                                        <Typography variant="body2" >{moneyCL(ticket?.net_total || 0)}</Typography>
                                    </Stack>

                                    {documentSelected?.id === 2 && (
                                        <Stack direction="row" justifyContent="space-between">
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>Monto Exento</Typography>
                                            <Typography variant="body2" >{moneyCL(0)}</Typography>
                                        </Stack>
                                    )}

                                    <Stack direction="row" justifyContent="space-between">
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>19% IVA</Typography>
                                        <Typography variant="body2" >{moneyCL(ticket?.IVA || 0)}</Typography>
                                    </Stack>

                                    <Divider sx={{ my: 1 }} />

                                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#516E80' }}>TOTAL</Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>{moneyCL(ticket?.gross_total || 0)}</Typography>
                                    </Stack>

                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Botones */}
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={2} justifyContent="center" mt={2} flexWrap="wrap">
                            <Button
                                variant="outlined"
                                onClick={goBack}
                                disabled={status === ApiStatus.FETCHING}
                                sx={{
                                    borderRadius: 2,
                                    color: '#516E80',
                                    borderColor: '#516E80',
                                    width: 180,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    "&:hover": {
                                        borderColor: '#314952',
                                        backgroundColor: "#f5f5f5",
                                    }
                                }}
                                startIcon={<ArrowBackIcon />}

                            >
                                Volver
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => onConfirmTicket(idticket)}
                                disabled={status === ApiStatus.FETCHING}
                                sx={{
                                    backgroundColor: '#516E80',
                                    color: '#fff',
                                    width: 180,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    "&:hover": {
                                        backgroundColor: '#3b5563'
                                    }
                                }}
                                endIcon={<CheckCircleIcon />}
                            >
                                Realizar Pedido
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    )
}